module.exports = __webpack_public_path__ + "static/4p-cover-d31cabacbb39fc88dbf417dc11d5bec7.jpg";